export const SEARCH_HISTORY_STORAGE_KEY = "searchHistory";

export const SEARCH_HISTORY_MAX_LENGTH = 5;

export const SHOW_ALL_FILTER_OPTIONS = Infinity;
